import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryExplorer from './components/CategoryExplorer';
import TrustStrip from './components/TrustStrip';
import AboutSection from './components/AboutSection';
import ExploreHub from './components/ExploreHub';
import GuidesSection from './components/GuidesSection';
import PillarArticles from './components/PillarArticles';
import FinalCTA from './components/FinalCTA';
import HomeSchema from './components/HomeSchema';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategoryExplorer />
        <TrustStrip />
        <AboutSection />
        <ExploreHub />
        <GuidesSection />
        <PillarArticles />
        <FinalCTA />
      </main>
      <HomeSchema />
      <Footer />
    </div>
  );
}